import { CVEditingSection, FullCV, isInternalAiNote } from '@cibli/shared';
import React from 'react';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface ComplementaryInfoProps {
  hasRQTH: FullCV['hasRQTH'];
  complementaryMentions: FullCV['complementaryMentions'];
  onEdit?: (section: CVEditingSection) => void;
  headingColor?: string;
}

const ComplementaryInfo: React.FC<ComplementaryInfoProps> = ({
  hasRQTH,
  complementaryMentions,
  onEdit,
  headingColor,
}) => {
  const { t } = useCVTranslation();

  const handleEdit = () => {
    if (onEdit) {
      onEdit('complementaryInfo');
    }
  };

  const editable = onEdit !== undefined;
  if (!hasRQTH && !complementaryMentions?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="mb-2 p-2 m-2">
        <h2
          className="text-[11px] font-black uppercase tracking-widest pb-1.5 mb-2.5"
          style={{ color: headingColor ?? '#000000' }}
        >
          {t('CV.complementaryInfo')}
        </h2>
        <div className="space-y-1.5">
          {hasRQTH && (
            <div className="text-[13px] leading-relaxed flex items-start gap-1.5">
              <span className="text-gray-400 mt-0.5">•</span>
              <span className="font-semibold">{t('CV.hasRQTH')}</span>
            </div>
          )}
          {(complementaryMentions ?? [])
            .filter(mention => mention.toUpperCase() !== 'RQTH' && !isInternalAiNote(mention))
            .map((mention, index) => (
              <div key={index} className="text-[13px] leading-relaxed flex items-start gap-1.5">
                <span className="text-gray-400 mt-0.5">•</span>
                <span>{mention}</span>
              </div>
            ))}
        </div>
      </div>
    </EditableSection>
  );
};

export default ComplementaryInfo;
